module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.1-252.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.6.1.md
// module id = 696
// module chunks = 262